module.exports = __webpack_public_path__ + "img/pl_Ecran 5.74273ded.png";